module.exports = __webpack_public_path__ + "media/images/icons/outlined/container-fc7cdcd4ecb8e4e15a7f57c07d0d5611.svg";